import React from 'react';
import ellipse from "../../../assets/pics/ellipse.png";
import Title from '../../atoms/Title';
import Text from '../../atoms/Text';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';



export default function Tableofnames({title, data}) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";

  const handleNavigate = (id) => {
    navigate(`/about.aspx?id=${id}`);
  };

  return (
    <div className='h-full'>
            <div className="bg-[#D8D7D7] mx-[10px] md:mx-[30px] lg:mx-[40px] rounded-b-lg">
                    <div className='text-start h-[54px] flex justify-start items-center ps-[20px]'>
                        <Title primary2>{title}</Title>
                    </div>
                    
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-3 text-start bg-[#F5F5F5] p-4 ps-[50px] rounded-[8px] shadow-md">
                        {data?.map((name, index) => (
                        <div key={index} className="flex justify-start items-center gap-x-2 bg-ed-400">
                            <div 
                                className='flex justify-start items-center gap-x-2 bg-rd-400'
                                onClick={() => handleNavigate(name.characterId)}
                                style={{ cursor: "pointer" }}
                                >

                                <img src={ellipse} alt="icon" className="w-4 h-4" />
                                <Text name>{(isArabic ? name.characterName : name.characterNameE) || t("common.noData")}</Text>

                            </div>
                        </div>
                        ))}
                    </div>
            </div>

            <div className="h-[1px] bg-[#D8D7D7] mt-4 w-full"></div>

    </div>
  );
}
